import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({
  id, btnText, checked, handleChange, name, value,
}) => (
  <label htmlFor={id} className={checked ? 'news-events-radio__btn active' : 'news-events-radio__btn'}>
    <input
      id={id}
      type="radio"
      name={name}
      value={value}
      onChange={(e) => { handleChange(e); }}
      checked={checked}
    />
    {btnText}
  </label>
);

export default Radio;

Radio.defaultProps = {
  checked: false,
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  btnText: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
